import { AbstractControl } from '@angular/forms';
// Service
import { ValidationContext } from './validation-context';
import { FormModelService } from './form-model.service';

export class VisibilityContext extends ValidationContext {

	constructor(
		control: AbstractControl,
		schemasService: FormModelService
	) {
		super(control, schemasService, true);
	}
}
